import React from 'react';
import styles from './NumberInput.module.css';

export interface NumberInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: number | string; // string per consentire input vuoto
  onChange: (value: number | string) => void; // Può restituire numero o stringa vuota
  // id, min, max, step, disabled, className, placeholder, name sono già inclusi in InputHTMLAttributes
}

export const NumberInput: React.FC<NumberInputProps> = ({
  value,
  onChange,
  className,
  ...rest
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const stringValue = event.target.value;
    if (stringValue === '') {
      onChange('');
    } else {
      const numValue = parseFloat(stringValue);
      // Evita di chiamare onChange con NaN se l'utente sta digitando qualcosa come "1." o "-"
      if (!isNaN(numValue) || stringValue === '-' || stringValue.endsWith('.')) {
         // Se è un numero valido o una stringa vuota o un potenziale numero in corso di digitazione
         if (!isNaN(numValue)) {
            onChange(numValue);
         } else if (stringValue === '') {
            onChange('');
         }
         // Non chiamare onChange per stringhe come "-" o "1." finché non sono valide o vuote
      }
    }
  };

  // Per visualizzare, se il valore è un numero, lo convertiamo in stringa.
  // Se è una stringa (es. vuota), la usiamo direttamente.
  const displayValue = typeof value === 'number' ? value.toString() : value;

  return (
    <input
      type="number"
      value={displayValue}
      onChange={handleChange}
      className={`${styles.numberInput} ${className || ''}`}
      {...rest}
    />
  );
};